// Based on
// https://dev.to/jslim/fading-up-sections-using-intersection-observer-3fhj

(function () {
  if (!window.IntersectionObserver) {
    const elements = document.getElementsByClassName('scroll-fadein');
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add('in-view');
    }
    return;
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -75px 0px',
    }
  );

  window.addEventListener('DOMContentLoaded', function () {
    const elements = Array.from(
      document.getElementsByClassName('scroll-fadein')
    );
    for (let element of elements) {
      observer.observe(element);
    }
  });
})();
